/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Downloads_Dropdown_Macos_Apple_SiliconInputs */

const en_downloads_dropdown_macos_apple_silicon = /** @type {(inputs: Downloads_Dropdown_Macos_Apple_SiliconInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`macOS (Apple Silicon)`)
};

const es_downloads_dropdown_macos_apple_silicon = /** @type {(inputs: Downloads_Dropdown_Macos_Apple_SiliconInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`macOS (Apple Silicon)`)
};

/**
* | output |
* | --- |
* | "macOS (Apple Silicon)" |
*
* @param {Downloads_Dropdown_Macos_Apple_SiliconInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const downloads_dropdown_macos_apple_silicon = /** @type {((inputs?: Downloads_Dropdown_Macos_Apple_SiliconInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Downloads_Dropdown_Macos_Apple_SiliconInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_downloads_dropdown_macos_apple_silicon(inputs)
	return en_downloads_dropdown_macos_apple_silicon(inputs)
});